export const CUSTOM_LESSON_INFO_LANDING_LINK_ID = 'customLesson.infoLanding.link';
